import React from "react";
import { CrookedStar, FourPointStar } from "../../../assets";

const whoCards = [
	{
		icon: "target",
		title: "Target-Oriented Learning",
		description:
			"Setiap siswa punya target yang berbeda. Karena itu, materi dan strategi belajar disesuaikan supaya progress terasa lebih jelas dan efektif.",
	},
	{
		icon: "chart",
		title: "Progress yang Bisa Dipantau",
		description:
			"Kamu bisa melihat perkembangan skill dan band score secara bertahap, lengkap dengan feedback yang membantu kamu berkembang lebih cepat.",
	},
	{
		icon: "heart",
		title: "Mentor yang Supportif",
		description:
			"Belajar bareng mentor berpengalaman yang nggak cuma ngajarin materi, tapi juga membantu kamu tetap konsisten dan percaya diri.",
	},
	{
		icon: "users",
		title: "Komunitas Belajar Positif",
		description:
			"Di ScholarsToday, kamu belajar bersama siswa lain yang punya tujuan yang sama, saling support, sharing progress, dan berkembang bareng.",
	},
	{
		icon: "book",
		title: "Materi Selalu Up-to-Date",
		description:
			"Kurikulum dan latihan terus diperbarui mengikuti tren soal IELTS terbaru supaya pembelajaran tetap relevan dan sesuai kebutuhan tes sekarang.",
	},
];

const whoStoryParagraphs = [
	"Banyak orang gagal melanjutkan studi ke kampus impian mereka bukan karena tidak mampu — tapi karena satu hambatan yang seharusnya bisa diatasi: skor IELTS.",
	"Dari situlah ScholarsToday lahir. Didirikan pada tahun 2025 di Kampung Inggris, Pare, Kabupaten Kediri — tempat yang sudah lama dikenal sebagai pusat belajar bahasa Inggris terbaik di Indonesia — ScholarsToday hadir dengan satu tujuan yang jelas:",
	(
		<>
			<span className="font-bold">memastikan IELTS tidak lagi menjadi penghalang bagi siapapun yang serius mengejar beasiswa.</span>
		</>
	),
];

const whoGuarantees = [
	{
		step: "Garansi 1",
		title: "Garansi Skor 7.0",
		description:
			"Jika skor simulasi atau real IELTS test tidak mencapai 7.0, program intensif tambahan 70 hari diberikan sepenuhnya gratis — tanpa biaya tambahan.",
	},
	{
		step: "Garansi 2",
		title: "Garansi Uang Kembali",
		description:
			"Berhasil Band 7 di real IELTS test? Kami kembalikan Rp5.000.000 sebagai bentuk apresiasi atas kerja kerasmu.",
	},
];

const iconPaths = {
	target: (
		<svg viewBox="0 0 24 24" aria-hidden="true" className="h-7 w-7 sm:h-10 sm:w-10">
			<circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
			<circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.8" />
			<circle cx="12" cy="12" r="1.4" fill="currentColor" />
		</svg>
	),
	chart: (
		<svg viewBox="0 0 24 24" aria-hidden="true" className="h-7 w-7 sm:h-10 sm:w-10">
			<path d="M5 18V6" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
			<path d="M11.5 18V10" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
			<path d="M18 18V13" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
			<path d="M4 18h16" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
		</svg>
	),
	heart: (
		<svg viewBox="0 0 24 24" aria-hidden="true" className="h-7 w-7 sm:h-10 sm:w-10">
			<path
				d="M12 20.3s-7-4.4-7-10.2A4.6 4.6 0 0 1 12 6.8a4.6 4.6 0 0 1 7 3.3c0 5.8-7 10.2-7 10.2Z"
				fill="none"
				stroke="currentColor"
				strokeLinejoin="round"
				strokeWidth="1.8"
			/>
		</svg>
	),
	users: (
		<svg viewBox="0 0 24 24" aria-hidden="true" className="h-7 w-7 sm:h-10 sm:w-10">
			<circle cx="8" cy="9" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
			<circle cx="16.5" cy="10.5" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
			<path d="M3.5 19c0-2.8 2.2-5 4.8-5s4.8 2.2 4.8 5" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
			<path d="M12.8 19c0-2.3 1.8-4 4-4 2.2 0 4 1.7 4 4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
		</svg>
	),
	book: (
		<svg viewBox="0 0 24 24" aria-hidden="true" className="h-7 w-7 sm:h-10 sm:w-10">
			<path d="M7 5.5h10a2 2 0 0 1 2 2V20H9a3 3 0 0 0-3 3V5.5Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.8" />
			<path d="M7 5.5a2 2 0 0 0-2 2V21" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
			<path d="M11 10h6M11 14h6" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
		</svg>
	),
};

const WhoCardIcon = ({ icon }) => <span className="flex h-12 w-24 items-center justify-center rounded-[14px] st-aboutus-who-card-icon sm:h-12 sm:w-28">{iconPaths[icon]}</span>;

const WhoIsScholarsToday = () => {
	return (
		<section className="st-aboutus-who overflow-hidden px-4 py-14 sm:py-16 lg:py-20">
			<div className="relative mx-auto w-full max-w-7xl">
				<img
					src={FourPointStar}
					alt=""
					aria-hidden="true"
					loading="lazy"
					className="pointer-events-none absolute left-[-4rem] top-[-4rem] hidden w-[16rem] rotate-[-8deg] md:block lg:top-[-10rem] lg:left-[-18rem] lg:w-[28rem]"
				/>
				<img
					src={CrookedStar}
					alt=""
					aria-hidden="true"
					loading="lazy"
					className="pointer-events-none absolute right-[-8rem] top-[34%] hidden w-[18rem] rotate-[28deg] md:block lg:right-[-24rem] lg:w-[32rem]"
				/>
				<img
					src={CrookedStar}
					alt=""
					aria-hidden="true"
					loading="lazy"
					className="pointer-events-none absolute bottom-[1rem] left-[-5rem] hidden w-[18rem] rotate-[16deg] md:block lg:top-[64rem] lg:left-[-32rem] lg:w-[32rem]"
				/>

				<div className="relative z-10">
					<div className="mx-auto max-w-[940px] text-center">
                        <div className="mx-auto mb-10 w-fit rounded-full bg-[#FFF7EB] px-8 py-2">
                            <p className="st-font-body text-[10px] font-bold tracking-[0.2em] text-[#C91B06] sm:text-[18px]">
                            -- PROFIL KAMI --
                            </p>
                        </div>
						<h2 className="st-aboutus-who-title st-font-display text-[42px] leading-[0.96] tracking-[-0.03em] sm:text-[56px] md:text-[64px] lg:text-[72px]">
							<span className="block">Siapa Itu</span>
							<span className="block font-bold italic st-aboutus-who-title-emphasis">ScholarsToday?</span>
						</h2>

						<p className="st-aboutus-who-intro st-font-body mx-auto mt-6 max-w-[920px] text-[14px] leading-[1.7] sm:text-[16px] md:text-[17px] lg:text-[18px]">
							ScholarsToday adalah <span className="font-bold">platform belajar IELTS</span> online di Indonesia yang membantu pelajar
							mencapai <span className="font-bold">target skor IELTS</span> dengan cara belajar yang lebih <span className="font-bold">terarah, terjangkau, dan
							didampingi mentor</span> berpengalaman. Mulai dari persiapan IELTS untuk <span className="font-bold">kuliah</span> luar negeri,
							<span className="font-bold"> beasiswa</span>, sampai kebutuhan <span className="font-bold">karier</span>, kami percaya setiap siswa punya <span className="font-bold">peluang</span> yang sama
							untuk <span className="font-bold"> berkembang dan go global!</span>
						</p>
					</div>

					<div className="mt-12 grid gap-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(360px,0.95fr)] lg:gap-12">
						<div className="max-w-[760px]">
							<h3 className="st-aboutus-who-section-title st-font-display text-[30px] leading-[1.02] sm:text-[38px] lg:text-[44px]">
								Awal Mula ScholarsToday
							</h3>

							<div className="mt-5 space-y-5 st-font-body text-[14px] leading-[1.75] sm:text-[15px] lg:text-[16px]">
								{whoStoryParagraphs.map((paragraph, index) => (
									<p key={index} className="st-aboutus-who-paragraph max-w-[650px]">
										{paragraph}
									</p>
								))}
							</div>

							<div className="mt-8 h-[2px] w-12 rounded-full st-aboutus-who-divider" />

							<p className="st-aboutus-who-paragraph st-font-body mt-8 max-w-[680px] text-[14px] leading-[1.75] sm:text-[15px] lg:text-[16px]">
								Kesungguhan itu bukan sekadar kata-kata. Kami mewujudkannya dalam dua garansi konkret:
							</p>

							<div className="mt-6 grid gap-4 sm:grid-cols-2 sm:gap-5 lg:max-w-[680px]">
								{whoGuarantees.map((item, index) => (
									<article
										key={item.step}
										className={`st-guarantee-card flex h-full flex-col gap-3 px-5 py-5 sm:px-6 sm:py-6 ${index === 1 ? "sm:translate-y-3" : ""}`}
										style={{ transform: index === 0 ? "rotate(0deg)" : "rotate(0deg)" }}
									>
										<p className="st-guarantee-heading st-font-body text-[9px] sm:text-[10px]">
											{item.step}
										</p>
										<h4 className="st-font-body st-guarantee-score text-[18px] leading-[1.05] sm:text-[20px] lg:text-[22px]">
											{item.title}
										</h4>
										<p className="st-font-body st-guarantee-cta text-[12px] leading-[1.7] sm:text-[13px] lg:text-[14px]">
											{item.description}
										</p>
									</article>
								))}
							</div>
						</div>

						<div className="lg:pt-16">
							<div className="space-y-5 sm:space-y-6">
								{whoCards.map((card) => (
									<article
										key={card.title}
										className="st-aboutus-who-card flex items-start gap-4 rounded-[18px] px-5 py-5 sm:gap-5 sm:px-6 sm:py-6"
									>
										<WhoCardIcon icon={card.icon} />

										<div className="min-w-0">
											<h4 className="st-aboutus-who-card-title st-font-body text-[16px] font-bold leading-[1.25] sm:text-[18px]">
												{card.title}
											</h4>
											<p className="st-aboutus-who-card-text st-font-body mt-2 text-[13px] leading-[1.6] sm:text-[14px] lg:text-[15px]">
												{card.description}
											</p>
										</div>
									</article>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default WhoIsScholarsToday;
